module.exports = __webpack_public_path__ + "static/media/campanha_menores_carolina_deslandes.98b30047.png";